import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import JobsTable from './jobs-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-expense-approval')) {
  ReactDOM.render(<JobsTable
    url= "/api/v1/portal/jobs/expense-approval"
    infiniteScroll={true}
    message_if_none = 'No jobs waiting for expense approval.'
  />,
document.getElementById('react-component-g4-logistics-portal-expense-approval'));
}
